"use strict";

/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
document.addEventListener("DOMContentLoaded", function (e) {
  navigationInit();
  rollingTextInit();
  effectsInit();
});

function navigationInit() {
  var mainMenu = document.querySelector(".main-navigation");
  if (!mainMenu) return;
  var menuToggle = mainMenu.querySelector(".menu-toggle");
  var linksWithChildren = mainMenu.querySelectorAll(".menu-item-has-children");
  var links = mainMenu.querySelectorAll('a');
  menuToggle.addEventListener("click", function (e) {
    document.body.classList.toggle("menu-toggled");

    if (menuToggle.getAttribute("aria-expanded") === "false") {
      menuToggle.setAttribute("aria-expanded", true);
    } else {
      menuToggle.setAttribute("aria-expanded", false);
    }
  });
  linksWithChildren.forEach(function (link, i) {
    // console.log(link);
    var dropDown = document.createElement("button");
    dropDown.className = "dropdown-toggle";
    dropDown.addEventListener("click", function (e) {
      link.classList.toggle("active");
    });
    link.prepend(dropDown);
  });
  links.forEach(function (link, i) {
    link.addEventListener('click', function (e) {
      document.body.classList.toggle("menu-toggled");
      menuToggle.setAttribute("aria-expanded", false);
    });
  });
}

function effectsInit() {
  document.querySelectorAll('.loop-title,.loop-meta p,.loop-content p,.work-broadcast').forEach(function (el, i) {
    el.classList.add('no-effect');
  });
  document.querySelectorAll('.entry-content :where(h1,h2,h3,h4,h5,h6,p,li,hr,.wp-block-button):not(.no-effect)').forEach(function (el, i) {
    gsap.from(el, {
      opacity: 0,
      y: '2rem',
      delay: .5,
      scrollTrigger: {
        trigger: el
      }
    });
  });
  document.querySelectorAll('.wp-block-gallery img').forEach(function (el, i) {
    gsap.from(el, {
      opacity: 0,
      scale: .8,
      stagger: .2,
      scrollTrigger: {
        trigger: el
      }
    });
  }); // ScrollTrigger.batch('.wp-block-gallery img', {
  // 	once: true,
  // 	onEnter: (elements) => {
  // 		// console.log('enter', elements);
  // 		gsap.fromTo(elements, {
  // 			opacity: 0,
  // 			scale: .8,
  // 		}, {
  // 			scale: 1,
  // 			opacity: 1,
  // 			stagger: 0.1,
  // 		})
  // 	},
  // });
}

function rollingTextInit() {
  var scrollingGalleries = document.querySelectorAll('.scrolling-gallery');
  scrollingGalleries.forEach(function (el, i) {
    var wrapper = document.createElement('div');
    wrapper.className = 'scrolling-gallery-wrapper';
    el.parentElement.appendChild(wrapper);
    wrapper.appendChild(el); // wrapper.innerHTML = '<div class="part">' + wrapper.innerHTML + '</div>';

    for (var index = 0; index < 2; index++) {
      var clonedEl = el.cloneNode(true);
      wrapper.appendChild(clonedEl);
    }
  });
}